import constants from '#packages/constants';
import type { EditorState } from '#packages/stateManagement';

const isConnectToDataDisabled = (state: EditorState): boolean =>
  state.featuresOverridden[constants.FEATURES.CONNECT_TO_DATA].isDisabled;
const isPasteDisabled = (state: EditorState): boolean =>
  state.featuresOverridden[constants.FEATURES.PASTE].isDisabled;

export { isConnectToDataDisabled, isPasteDisabled };
